import { render, staticRenderFns } from "./ViewDepts.vue?vue&type=template&id=0fb2e917&"
import script from "./ViewDepts.vue?vue&type=script&lang=js&"
export * from "./ViewDepts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports